import { useDispatch, useSelector } from "react-redux";
import { validateChatUrl } from "#src/features/Incomming/api/validateChatUrl.js";
import { reqChatStatus } from "#src/modules/reducers/arsUrlValidator/checkChatStatus.js";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const useCheckChatStatus = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const channelId = useSelector((state) => state.checkArsStatus.channelId);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');
  
  const status = useSelector((state) => state.checkChatStatus.status);
  const arsStatus = useSelector((state) => state.checkArsStatus.status);
  const channelCd = useSelector((state) => state.checkArsStatus.channelCd);
  const channelTypeCd = useSelector((state) => state.checkArsStatus.channelTypeCd);

  useEffect(() => {
    if (channelId) {
      const api = validateChatUrl(channelId, { userId: userId, inflowType: channelCd, chatBotType: channelTypeCd });
      dispatch(reqChatStatus(api));
    }
  }, [channelId]);

  useEffect(() => {
    if (status) {
      // arsStatus, chatStatus 둘 중 하나라도 available 상태가 아니면 expired로 이동
      // channelId가 없다는 건 기존에 한번 /expired로 이동해서 데이터가 초기화된 것을 의미
      if ((status === "expired" || arsStatus === "expired") || !channelId) {
        navigate("/expired", { replace: true });
      }
    }
  }, [status]);
};

export default useCheckChatStatus;
